import { getContextualThemeForModule } from "../contextualTheme";

const chords = getContextualThemeForModule("chords");

/** Tema del hub / estudio de acordes — canvas Serenity + acento ámbar del módulo. */
export const CHORD_HUB_THEME = {
  bg: "#1c1a19",
  bgElevated: "#242220",
  bgCard: "#2a2826",
  bgCardHover: "#32302e",
  border: "rgba(245, 240, 235, 0.08)",
  borderHover: "rgba(245, 240, 235, 0.15)",
  textMain: "#f5f0eb",
  textMuted: "#a09890",
  textDim: "#6a635c",
  accent: chords.accent,
  accentHover: chords.accentHover,
  accentGlow: "rgba(245, 158, 11, 0.28)",
  accentSoft: "rgba(245, 158, 11, 0.12)",
} as const;
